import { BiLogoFlutter } from "react-icons/bi";

const flutterIcon = <BiLogoFlutter />;


const data = [
  {
    id: 1,
    icon: flutterIcon,
    title: "Flutter",
  },
  {
    id: 2,
    icon: flutterIcon,
    title: "Flutter",
  },
  {
    id: 3,
    icon: flutterIcon,
    title: "Flutter",
  },
  {
    id: 4,
    icon: flutterIcon,
    title: "Flutter",
  },
  {
    id: 5,
    icon: flutterIcon,
    title: "Flutter",
  },
  {
    id: 6,
    icon: flutterIcon,
    title: "Flutter",
  },
];

export default data;
